// extracted by mini-css-extract-plugin
export var box = "Directions-module--box--4d611";
export var box_md = "Directions-module--box_md--dfd2a";
export var box_xmd = "Directions-module--box_xmd--d3fd1";
export var box_flex = "Directions-module--box_flex--cd752";
export var box_lg = "Directions-module--box_lg--3ea9b";
export var box_sm = "Directions-module--box_sm--6b91b";
export var box_outer = "Directions-module--box_outer--eb9cd";
export var box_whiteBg = "Directions-module--box_white-bg--edfbe";
export var box_noMarginBottom = "Directions-module--box_no-margin-bottom--86e23";
export var box_noPadding = "Directions-module--box_no-padding--69d4a";
export var box_outerGray = "Directions-module--box_outer-gray--8362e";
export var box_dark = "Directions-module--box_dark--48245";
export var box_zIndex = "Directions-module--box_z-index--c984a";
export var box_zIndex6 = "Directions-module--box_z-index-6--b3145";
export var box_eventsWithLine = "Directions-module--box_events-with-line--b1cd2";
export var box_featuresAo = "Directions-module--box_features-ao--4d6d0";
export var box_verticalPaddings = "Directions-module--box_vertical-paddings--7fcef";
export var clearP = "Directions-module--clearP--5ee5b";
export var clearP_vc = "Directions-module--clearP_vc--06df0";
export var wrapper = "Directions-module--wrapper--c385e";
export var layout = "Directions-module--layout--e6d52";
export var fadeInAnimation = "Directions-module--fadeInAnimation--027a3";
export var placeHolderShimmer = "Directions-module--placeHolderShimmer--b46d8";